import { CheckCircleOutlined } from '@ant-design/icons'
import calendarX from '@assets/CustomIcons/calander-x.png'
import calendarQuestion from '@assets/CustomIcons/calendar-question.png'
import calendarTime from '@assets/CustomIcons/calendar-time.png'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import type { GroupCellRendererParams } from 'ag-grid-community'
import React, { useMemo } from 'react'

type StatusProps = { params: GroupCellRendererParams<unknown, string | string[]> }

const icons = {
  Expired: <img src={calendarX} alt={'calendar-x icon'} style={{ height: '13px' }} />,
  'Expires Soon': <img src={calendarTime} alt={'calendar-time icon'} style={{ height: '13px' }} />,
  'Missing Date': <img src={calendarQuestion} alt={'calendar-question icon'} style={{ height: '13px' }} />,
  Valid: <CheckCircleOutlined style={{ color: 'green' }} />,
}
const states = ['Expired', 'Missing Date', 'Expires Soon']

export const Status = (params) => {
  const sortedCounted = useMemo(() => {
    if (params.value) {
      return { [params.value]: 1 }
    }

    if (params?.node?.group) {
      const getStatus = (node) => {
        if (node.data) return node.data.status
        if (node.group) return node.childrenAfterGroup.map(getStatus)
      }
      const statuses = params.node.childrenAfterGroup.flatMap(getStatus)
      return statuses.reduce((acc, curr) => {
        acc[curr] = (acc[curr] || 0) + 1
        return acc
      }, {})
    }
  }, [params])

  if (typeof params?.value === 'string') {
    return (
      <Horizontal flex={1} verticalCenter>
        {icons[params?.value]}
        <Texto className={'ml-2'}>{params.value}</Texto>
      </Horizontal>
    )
  }
  return (
    <Horizontal verticalCenter>
      {states.map((state, index) => (
        <Horizontal flex={1} verticalCenter key={state} className={index !== 0 && 'ml-1'}>
          {sortedCounted?.[state] && (
            <>
              {icons[state]}
              <Texto className={'ml-1'}>{sortedCounted[state]}</Texto>
            </>
          )}
        </Horizontal>
      ))}
    </Horizontal>
  )
}
